import React from 'react';
import Button from '../Button';
import Empty from '../Empty';
import FontAwesomeIcon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from './TableIndex';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Skeleton from 'src/components/Skeleton/Skeleton';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import EmailTemplateForm from '../EmailTemplateForm';
import { fetchEmailTemplates, updateEmailTemplate, setEmailTemplateForm, clearEmailTemplateForm, setEmailTemplates, clearEmailTemplates } from '../../store/actions/emailTemplates';

const SKELETON_ROW_COUNT = 12;

class EmailTemplatesTable extends React.Component {
  state = {
    showOverlay: false,
    /* FormLoader (redux) starts false and only flips true after fetchEmailTemplates
     * dispatches in componentDidMount. Guard against the empty-state splash
     * flashing on first paint before redux flagged loading. */
    isInitialLoading: true,
  };

  componentDidMount(){
    const {user,fetchEmailTemplates}=this.props;
    fetchEmailTemplates(user?.id)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.loader && this.props.loader && this.state.isInitialLoading) {
      this.setState({ isInitialLoading: false });
    }
  }

edit(data){
  const {setEmailTemplateForm, user} = this.props;
  this.setState({ showOverlay: true})
  setEmailTemplateForm({...data, userId:user?.id})
}
  render() {
    const { loader } = this.props;
    const {emailTemplates}=this.props.emailTemplates;
    const emailTemplatesData =[...emailTemplates].reverse();
    const { showOverlay, isInitialLoading } = this.state;
    const isLoading = loader || isInitialLoading;
    const isEmpty = emailTemplates.length === 0;

    const emptyNode = (
      <Empty
        direction="ttb"
        headline="No Email Templates Yet"
        strapline="Keep all your Email Templates here so it’s easier for you to manage."
        image={(
          <img
            alt="No Email Templates yet"
            src="/assets/empty/contacts.svg"
          />
        )}
      />
    );

    const tableColumns = [
      {
        label: 'Action',
        accessor: 'name',
        cell: data => <div title={data.name}>{data.name}</div>
      }, {
        label: 'Subject',
        accessor: 'subject',
        cell: data => <div title={data.subject}>{data.subject}</div>
      },
      {
        label: 'Role',
        accessor: 'role',
        cell: data => data.role ? <div title={data.role}>{data.role}</div>:<div title='N/A'>N/A</div>
      },
      {
        xsHide: true,
        cell: data => (
          <Hidden>
            <Button
              color="semantic"
              label={(
                <FontAwesomeIcon
                  glyph="pencil"
                  weight="light"
                />
              )}
              onClick={() => this.edit(data)}
            />
          </Hidden>
        )
      }
    ];

    const skeletonColumns = tableColumns.map(c => ({
      ...c,
      cell: () => <Skeleton variant="text" width="70%" />,
    }));

    const skeletonData = Array.from(
      { length: SKELETON_ROW_COUNT },
      (_, i) => ({ id: `email-template-skeleton-${i}` })
    );

    return (
      <>
        {isLoading ? (
          <Table columns={skeletonColumns} data={skeletonData} />
        ) : isEmpty ? (
          emptyNode
        ) : (
          <Table columns={tableColumns} data={emailTemplatesData} />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <EmailTemplateForm
              from={'EmailTemplateForm'}
              breadcrumb={'Updating'}
              onSaveNote={()=>alert('Clicked..!!')}
              onClose={() => this.setState({ showOverlay: false })}
            />
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  loader: selectFormLoader(state),
  user:selectAuthenticatedUser(state),
  emailTemplates:state.emailTemplates,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchEmailTemplates, 
  updateEmailTemplate, 
  setEmailTemplateForm, 
  clearEmailTemplateForm, 
  setEmailTemplates, 
  clearEmailTemplates
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesTable);
